import { showToast, removeToast } from '../components/ToastContainer';

/**
 * Toast utility functions for more convenient usage throughout the app
 */

/**
 * Show a success toast
 * @param {string} message - Message to show
 * @param {number} duration - Duration in milliseconds (default: 3000ms)
 * @returns {number} Toast ID that can be used to remove the toast
 */
export const showSuccess = (message, duration = 3000) => {
  return showToast('success', message, duration);
};

/**
 * Show an error toast
 * @param {string} message - Message to show
 * @param {number} duration - Duration in milliseconds (default: 4000ms)
 * @returns {number} Toast ID that can be used to remove the toast
 */
export const showError = (message, duration = 4000) => {
  return showToast('error', message, duration);
};

/**
 * Show an info toast
 * @param {string} message - Message to show
 * @param {number} duration - Duration in milliseconds (default: 3000ms)
 * @returns {number} Toast ID that can be used to remove the toast
 */
export const showInfo = (message, duration = 3000) => {
  return showToast('info', message, duration);
};

/**
 * Show a warning toast
 * @param {string} message - Message to show
 * @param {number} duration - Duration in milliseconds (default: 4000ms)
 * @returns {number} Toast ID that can be used to remove the toast
 */
export const showWarning = (message, duration = 4000) => {
  return showToast('warning', message, duration);
};

/**
 * Handle API error and show appropriate toast
 * @param {Error} error - Error object from catch block
 * @param {string} fallbackMessage - Fallback message if error response doesn't have one
 */
export const handleApiError = (error, fallbackMessage = 'An error occurred') => {
  console.error(error);
  
  let message = fallbackMessage;
  
  if (error.response && error.response.data) {
    if (error.response.data.message) {
      message = error.response.data.message;
    } else if (error.response.data.msg) {
      message = error.response.data.msg;
    }
  }
  
  return showError(message);
};

export { removeToast };
